import { gtm } from '../modules/gtm.js';

export const searchMethods = {

	_initSearch() {
		const container = document.getElementById( this.container );
		const s         = window.lbhMapStrings || {};

		const wrap = document.createElement( 'div' );
		wrap.className = 'map-search';
		wrap.innerHTML = `
			<input  type="text"
					class="map-search__input"
					placeholder="${ s.searchPlaceholder || 'Cerca una località…' }"
					autocomplete="off"
					aria-label="${ s.searchAriaLabel || 'Cerca una località in Italia' }">
			<ul class="map-search__suggestions" role="listbox" hidden></ul>`;

		container.appendChild( wrap );

		const input = wrap.querySelector( '.map-search__input' );
		const list  = wrap.querySelector( '.map-search__suggestions' );
		let timer;

		input.addEventListener( 'input', () => {
			clearTimeout( timer );
			const q = input.value.trim();
			if ( q.length < 2 ) { list.hidden = true; list.innerHTML = ''; return; }
			timer = setTimeout( () => this._fetchSuggestions( q, list, input ), 300 );
		} );

		input.addEventListener( 'keydown', ( e ) => {
			if ( e.key === 'Escape' ) { list.hidden = true; input.blur(); }
		} );

		document.addEventListener( 'click', ( e ) => {
			if ( ! wrap.contains( e.target ) ) list.hidden = true;
		} );
	},

	async _fetchSuggestions( query, list, input ) {
		try {
			const lang = this.lang || 'it';
		const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${ encodeURIComponent( query ) }.json`
				+ `?country=it&language=${ lang }&limit=5&access_token=${ this.accessToken }`;

			const res = await fetch( url );
			if ( ! res.ok ) return;

			const { features } = await res.json();

			list.innerHTML = '';

			if ( ! features.length ) { list.hidden = true; return; }

			features.forEach( f => {
				const li = document.createElement( 'li' );
				li.className   = 'map-search__item';
				li.textContent = f.place_name;
				li.setAttribute( 'role', 'option' );
				li.addEventListener( 'click', () => {
					gtm.mapSearch( { search_term: f.place_name } );
					input.value = f.place_name;
					list.hidden = true;
					const [ lng, lat ] = f.center;
					this.map.flyTo( { center: [ lng, lat ], zoom: 11, duration: 1200 } );
				} );
				list.appendChild( li );
			} );

			list.hidden = false;
		} catch {
			// geocoding is non-critical — fail silently
		}
	},
};
